import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchWithAuth } from '../services/AuthService';
import { Spinner, Button } from 'react-bootstrap';
import AdminStatsSignupChart from './admin/AdminStatsSignupChart';
import AdminStatsLandingChart from './admin/AdminStatsLandingChart';
import AdminStatsSessionsChart from './admin/AdminStatsSessionsChart';
import AdminStatsQuizStacked from './admin/AdminStatsQuizStacked';
import AdminStatsNotes from './admin/AdminStatsNotes';

const AdminStats = () => {
  const navigate = useNavigate();    
  const [loading, setLoading] = useState(true);
  const [userStats, setUserStats] = useState([]);
  const [globalStats, setGlobalStats] = useState([]);
  const [error, setError] = useState(null);
  const [aggregating, setAggregating] = useState(false);
  const [message, setMessage] = useState('');

  const fetchStats = async () => {
    try {
      setLoading(true);
      const response = await fetchWithAuth('/api/admin/stats');
      if (!response.ok) throw new Error('Erreur lors du chargement des statistiques');
      const data = await response.json();
      setUserStats(data.userStats || []);
      setGlobalStats(data.globalStats || []);
    } catch (err) {
      console.error(err);
      setError(err.message || 'Erreur de chargement');
      navigate('/');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  const handleAggregate = async () => {
    setAggregating(true);
    setMessage('');
    try {
      const response = await fetchWithAuth('/api/admin/aggregate', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            },      
        });
      const data = await response.json();
      if (data.success) {
        setMessage('✅ Agrégation terminée avec succès !');
        await fetchStats(); // 🔄 rafraîchit les stats après l’agrégation
      } else {
        setMessage('❌ Erreur lors de l’agrégation.');
      }
    } catch (err) {
      console.error(err);
      setMessage('❌ Erreur réseau ou serveur.');
    } finally {
      setAggregating(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <Spinner animation="border" variant="primary" />
        <span className="ml-3">Chargement des statistiques...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center text-red-600 mt-10">
        <p>❌ {error}</p>
      </div>
    );
  }

  return (
    <div className="p-8 max-w-6xl mx-auto space-y-10">
      {/* En-tête avec le bouton */}
      <div className="flex justify-between items-center mb-6">
        <Button
          variant="primary"
          onClick={handleAggregate}
          disabled={aggregating}
        >
          {aggregating ? 'Agrégation en cours...' : 'Lancer l’agrégation'}
        </Button>
      </div>

      {message && (
        <p
          className={`text-center text-sm ${
            message.includes('✅') ? 'text-green-600' : 'text-red-600'
          }`}
        >
          {message}
        </p>
      )}

      {/* Graphiques */}
      <AdminStatsSignupChart globalStats={globalStats} />
      <AdminStatsLandingChart globalStats={globalStats} userStats={userStats} />
      <AdminStatsSessionsChart userStats={userStats} />
      <AdminStatsQuizStacked userStats={userStats} />
      <AdminStatsNotes userStats={userStats} />
    </div>
  );
};

export default AdminStats;
